"use strict";

require("core-js/modules/es6.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = commonCreditorLookup;

function commonCreditorLookup(name) {
  try {
    var res = {
      name: name,
      address: null
    };

    if (/^ACCT CORP$/i.test(name)) {
      res.name = 'AcctCorp of Southern Nevada';
      res.address = {
        street1: '4955 S Durango Dr # 177',
        city: 'Las Vegas',
        state: 'NV',
        zipcode: '89113'
      };
    } else if (/^ERC$/i.test(name) || /^Enhanced Resource Centers$/i.test(name)) {
      res.name = 'Enhanced Resource Centers';
      res.address = {
        street1: '8014 Bayberry Rd.',
        city: 'Jacksonville',
        state: 'FL',
        zipcode: '32256'
      };
    } else if (/^SECURED RES$/i.test(name)) {
      res.name = 'Secured Resolutions';
      res.address = {
        street1: 'P.O. Box 1408',
        city: 'Buffalo',
        state: 'NY',
        zipcode: '14226'
      };
    } else if (/^FED LOAN SERV$/i.test(name)) {
      res.name = 'FedLoan Servicing';
      res.address = {
        street1: 'P.O. Box 530210',
        city: 'Atlanta',
        state: 'GA',
        zipcode: '30353-0210'
      };
    } else if (/^JEFFERSON CAPITAL SYST$/i.test(name) || /^JEFFCAPSYS$/i.test(name)) {
      res.name = 'Jefferson Capital Systems, LLC';
      res.address = {
        street1: 'P.O. Box 772813',
        city: 'Chicago',
        state: 'IL',
        zipcode: '60677-2813'
      };
    } else if (/^THD\/CBNA$/i.test(name)) {
      res.name = 'Home Depot Credit Services';
      res.address = {
        street1: 'P.O. Box 790328',
        city: 'St. Louis',
        state: 'MO',
        zipcode: '63179'
      };
    } else if (/^CCB\/CHLDPLCE$/i.test(name)) {
      res.name = 'Comenity Capital Bank Children’s Place Credit Card';
      res.address = {
        street1: 'P.O. Box 659820',
        city: 'San Antonio',
        state: 'TX',
        zipcode: '78268-9120'
      };
    } else if (/^CREDIT COLL$/i.test(name)) {
      res.name = 'Credit Collection Services';
      res.address = {
        street1: '2 Wells Ave',
        city: 'Newton',
        state: 'MA',
        zipcode: '02459'
      };
    } else if (/^AMERICAN ADJUSTMENT BU$/i.test(name)) {
      res.name = 'American Adjustment Bureau';
      res.address = {
        street1: '73 Field St.',
        city: 'Waterbury',
        state: 'CT',
        zipcode: '06702'
      };
    } else if (/^CHASE CARD$/i.test(name)) {
      res.name = 'Chase Cardmember Services';
      res.address = {
        street1: 'P.O. Box 6294',
        city: 'Carol Stream',
        state: 'IL',
        zipcode: '60197-6294'
      };
    } else if (/^ECMC\/AMERICAN STUDEN A$/i.test(name)) {
      res.name = 'ECMC/American Student Assistance';
      res.address = {
        street1: 'Saltonstall Building',
        street2: '100 Cambridge St #1600',
        city: 'Boston',
        state: 'MA',
        zipcode: '02114'
      };
    } else if (/^CRDT SYSTEMS$/i.test(name)) {
      res.name = 'Credit Systems International, Inc.';
      res.address = {
        street1: 'P.O. Box 1088',
        city: 'Arlington',
        state: 'TX',
        zipcode: '76004'
      };
    } else if (/^PORTFOLIO RECOV ASSOC$/i.test(name) || /^PORTFOLIO RC$/i.test(name)) {
      res.name = 'Portfolio Recovery Associates, LLC';
      res.address = {
        street1: '120 Corporate Blvd',
        city: 'Norfolk',
        state: 'VA',
        zipcode: '23502'
      };
    } else if (/^COLLECTION$/i.test(name) || /^MIDLAND FUND$/i.test(name)) {
      res.name = 'Midland Credit Management';
      res.address = {
        street1: 'P.O. Box 939069',
        city: 'San Diego',
        state: 'CA',
        zipcode: '92193'
      };
    } else if (/^DEPTEDNELNET$/i.test(name)) {
      res.name = 'Department of Education - Nelnet';
      res.address = {
        street1: '3015 S PARKER RD SUITE 400',
        city: 'Aurora',
        state: 'CO',
        zipcode: '80014'
      };
    } else if (/^Paypal$/i.test(name) || /^Synchrony Bank$/i.test(name)) {
      res.name = 'PayPal Credit';
      res.address = {
        street1: 'P.O. Box 71202',
        city: 'Charlotte',
        state: 'NC',
        zipcode: '28272-1202'
      };
    } else if (/^ONEMAIN$/i.test(name)) {
      res.name = 'OneMain';
      res.address = {
        street1: 'PO Box 742536',
        city: 'Cincinnati',
        state: 'OH',
        zipcode: '45274-2536'
      };
    } else if (/^JH PORT DEBT$/i.test(name)) {
      res.name = 'JH Portfolio Debt Equities';
      res.address = {
        street1: '5757 Phantom Drive',
        street2: 'Suite 225',
        city: 'Hazelwood',
        state: 'MO',
        zipcode: '63042'
      };
    } else if (/^DFS\/WEBBANK$/i.test(name)) {
      res.name = 'WebBank Dell-Financial-Services';
      res.address = {
        street1: 'PO BOX 6403',
        city: 'Carol Stream',
        state: 'IL',
        zipcode: '60197-6403'
      };
    } else if (/^COMNWLTH FIN$/i.test(name)) {
      res.name = 'COMNWLTH FIN';
      res.address = {
        street1: '245 Main Street',
        city: 'Scranton',
        state: 'PA',
        zipcode: '18519'
      };
    }

    return res;
  } catch (e) {
    console.log(e);
  }
}